import { BehaviorTypes, DeviceTypes, PositionTypes } from '@/typings/enums/enums';
import { AddonEditItem } from '@/typings/interfaces/data/campaign';
import { GameWofData } from '@/components/games/wof/Data';
import { GameDataSpinTheBottle } from '@/components/games/spinthebottle/Model';
import { ContentType } from '@/components/layout/section/SectionBaseModel';
import { CSSProperties } from 'vue';

export interface MetricData {
  [key: string]: string | number;
}

export interface ReplacementTags {
  [key: string]: string | number;
}

export interface InstantWinData {
  [key: string]: string | number;
}

export type GameData = GameDataSpinTheBottle[] | GameWofData[];

export interface FlowRegistrationInfo {
  id: number;
  token: string;
  pages: number[];
}

export interface GameSectionImageOverlay {
  enabled: boolean;
  behavior: BehaviorTypes;
  src?: string;
  overlay?: string; //This is a color, could be eg: ffffff or #ffffff
  position: PositionTypes;
  tileRepeat?: string;
  overwriteMobile?: boolean;
}

export interface SectionOverlayContent {
  type: ContentType;
  content: string;
}

export interface GameSectionOverlayContent {
  style: CSSProperties;
  content: SectionOverlayContent[];
}

export interface GameTestDate {
  enabled: boolean;
  date: string;
}

export interface GlobalState {
  metricData: MetricData | null;
  replacementTags: ReplacementTags;
  instantWinData: InstantWinData | null;
  staticFormData: Record<string, string>;
  staticQueryParams: Record<string, string>;
  gameData: GameData | null; // gameData is only being used on Wof & Spinthebottle game
  gameWinner: boolean | null;
  gameEnded: boolean;
  addonsData?: Record<string, AddonEditItem>;
  currentDevice: DeviceTypes | null;
  initializationTime: number | undefined;
  flowRegistrationInfo?: FlowRegistrationInfo;
  gameSectionImageOverlay?: GameSectionImageOverlay;
  gameTestDate?: Date;
  mountedSections: number[];
  mountedFlowPages: number[];
}

export const state = (): GlobalState => {
  return {
    metricData: null,
    replacementTags: {},
    gameData: null,
    gameWinner: null,
    gameEnded: false,
    instantWinData: null,
    staticFormData: {},
    staticQueryParams: {},
    addonsData: undefined,
    currentDevice: null,
    initializationTime: new Date().getTime(),
    flowRegistrationInfo: undefined,
    gameSectionImageOverlay: undefined,
    gameTestDate: undefined,
    mountedSections: [],
    mountedFlowPages: []
  };
};
